import { render } from "./ModalManageUser.vue?vue&type=template&id=7b8e6ed4"
import script from "./ModalManageUser.vue?vue&type=script&lang=js"
export * from "./ModalManageUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__